export default "__VITE_ASSET__CuXoZ$hb__"